// eslint-disable-next-line jst-gyl/check-keywords
import { RegisterErpRequest, AccessToken, CompanyContract } from '@servicesTypings/companyRequest'
import { ListUserUsingGet1Params, CompanyUserVo, SubAccountPwdParam } from '@servicesTypings/drpRequest'
import { companyRequest, openCompanyRequest, securityRequest, openSecurityRequest, drpRequest } from '@/utils/request'
import { fullAppCode } from '@/utils/singleApp'
import { ACCOUNT_PASSWORD, SMS_CODE, SECOND_AUTH, QR_LOGIN, LOGIN_SUCCESS_BIND_QR } from '@/modules/account/constance'

const headers = {
    appCode: fullAppCode
}

let refreshPath = '/open/loginOrRegister/refreshToken'

if (PROJECT_CONFIG.terminalName === 'OP') {
    refreshPath = '/open/loginOrRegister/refreshToken'
}

export function login(params) {
    let loginPath = '/open/v2/login/gyl/accountLogin'
    let method = 'post'
    let paramsKey = 'data'
    if (PROJECT_CONFIG.terminalName === 'OP') {
        loginPath = '/open/v2/login/op/login'
    }
    const { loginType, ...restParams } = params

    if (loginType === ACCOUNT_PASSWORD) {
        loginPath = '/open/v2/login/gyl/accountLogin'
    }
    if (loginType === SMS_CODE) {
        loginPath = '/open/v2/login/gyl/smsLogin'
    }
    if (loginType === SECOND_AUTH) {
        loginPath = '/open/v2/login/gyl/idaasVerificationLogin'
    }
    if (loginType === QR_LOGIN) {
        loginPath = '/open/v2/login/qrcode/login'
        method = 'get'
        paramsKey = 'params'
    }
    return openSecurityRequest[method](loginPath, {
        [paramsKey]: restParams,
        // 因为后端不知道什么版本，就会去全量拉ERP的权限接口，所以传一个appCode让后端过滤一下权限
        headers
    })
}

export function bind(params) {
    let bindPath = '/open/v2/login/qrcode/account/bind' // 扫码成功后，通过账密登录完成绑定接口
    let request = openSecurityRequest

    const { bindType, ...restParams } = params
    if (bindType === SMS_CODE) {
        bindPath = '/open/v2/login/qrcode/sms/bind'
    }

    if (bindType === LOGIN_SUCCESS_BIND_QR) {
        bindPath = '/thirdparty/bind'
        request = securityRequest
    }

    // if (bindType === SECOND_AUTH) {
    //     bindPath = '/open/v2/login/gyl/idaasVerificationLogin'
    // }

    return request.post(bindPath, {
        data: restParams,
        // 因为后端不知道什么版本，就会去全量拉ERP的权限接口，所以传一个appCode让后端过滤一下权限
        headers
    })
}

export function logout() {
    // 后端统一退出接口
    return securityRequest.get('/open/logout')
}

// 注册ERP账号 公司名称必填
/**
 * PC注册ERP账号并登录
 */
export function erpRegisterAndLoginV2(data: RegisterErpRequest): API.Res<AccessToken> {
    return openCompanyRequest.post('/open/loginOrRegister/v2/registerErpAccountForPc', { data })
}

export function refreshToken(data) {
    return openCompanyRequest.post(refreshPath, {
        data
    })
}

// 更新最后登录时间和身份
export function updateLastLoginTimeAndSide(side) {
    return drpRequest.post('/user/supplier/updateLastLoginTimeAndSide', {
        data: {
            side
        }
    })
}

// 是否可以切换身份
export function canChangeUserIdentify() {
    return drpRequest.get('/user/canChangeUserIdentify')
}

// 是否可以切换身份
/**
 * 查询用户列表
 */
export function listUser(params: ListUserUsingGet1Params): API.Res<CompanyUserVo[]> {
    return drpRequest.get('/user/listUser', { params })
}

// erp联动
export function erpJointLoginGyl2(headers, data) {
    return openSecurityRequest.post('/open/erpJointLoginGyl', {
        data,
        headers
    })
}

// erp连登 仅适用于erp内嵌打单和售后
export function erpJointLoginGylFast(headers, data) {
    return openSecurityRequest.post('/open/union/login', {
        data,
        headers
    })
}

// erp联动新 epass
export function epaasJointLoginGyl(data) {
    return openSecurityRequest.post('/open/epaasJointLoginGyl', {
        data
    })
}

// 获取当前用户合同版本 （2022/11/4 合同版本优化 这个接口是新的）
/**
 * 获取当前用户合同版本
 */
export function getContractVersion(): API.Res<CompanyContract> {
    return companyRequest.post('/companyContract/getCompanyContract')
}

// 更新用户密码
/**
 * 修改账号密码
 */
export function updatePassword(data: SubAccountPwdParam): API.Res<object> {
    return drpRequest.post('/subAccount/updatePwd', { data })
}

// 获取code码
/**
 * 获取授权码
 */
export function getLoginCode(): API.Res<string> {
    return companyRequest.get('/login/code')
}

export function afterLogin(data) {
    return companyRequest.post(`/after/login/action`, {
        data,
        // 因为后端不知道什么版本，就会去全量拉ERP的权限接口，所以传一个appCode让后端过滤一下权限
        headers
    })
}

// 同步子账号
/**
 * 同步子账号
 */
export function syncSubAccount(): API.Res<object> {
    return drpRequest.post('/user/syncSubAccount')
}

// 同步合作申请次数
/**
 * 同步合作次数
 */
export function syncApplyCooperationNum(): API.Res<null> {
    return drpRequest.get('/myPartner/syncApplyCooperationNum')
}

/**
 * 根据登录态获取票据接口（目前票据的有效期是 1 分钟，用完即毁）
 */
export function getTicket(data) {
    return securityRequest.post('/security/user/getTicket', {
        data
    })
}

/**
 * 根据票据获取当前用户的 token
 */
export function getTokenByTicket(params) {
    return openSecurityRequest.post('/open/v2/login/getTokenByTicket', {
        params
    })
}
